module.exports = __webpack_public_path__ + "static/media/home-dibujo.bd5027db.png";